import { FolderState, folderState } from './folder'
import { DialogState, dialogState } from './dialog'
import { UserState, userState } from './user'
import { getLocale } from '@/utils/dom'
export type State = FolderState & DialogState & UserState & {
  loading: Boolean,
  language: 'zh-cn' | 'en'
}
export default {
  language: getLocale(),
  loading: false,
  ...folderState,
  ...dialogState,
  ...userState,
}
